import { render } from "./ProducedGasCompositions.vue?vue&type=template&id=55b359f2"
import script from "./ProducedGasCompositions.vue?vue&type=script&lang=js"
export * from "./ProducedGasCompositions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__